import { render } from "./FeaturedServiceResult.vue?vue&type=template&id=a000676e"
import script from "./FeaturedServiceResult.vue?vue&type=script&lang=js"
export * from "./FeaturedServiceResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__